// RISKS.md/P2.27: OS-level and browser-level blocks BOTH reject with NotAllowedError, so only the
// message tells them apart — Chrome says "Permission denied by system" for the former (Windows and
// macOS). Matched loosely: the string is in no spec, and an unmatched variant falls back to the
// browser-settings copy, which is the safer default because the user can actually reach it.
export const isSystemDenial = (e: any) =>
  typeof e?.message === 'string' && e.message.toLowerCase().includes('denied by system')

// RISKS.md/P2.38: name the PHYSICAL device, not the alias. Chrome lists audio devices twice — once
// under their own id and again as `'default'` / `'communications'`, whose labels carry a LOCALIZED
// prefix. Naming one of those in a sentence reads oddly, and stripping that prefix as text
// would only work in the locales someone thought to handle. `groupId` ties the alias to the real
// device, so resolve through that instead.
const ALIAS_IDS = ['default', 'communications']
// Device labels are USER-settable and notification bodies render via dangerouslySetInnerHTML with
// i18next's escaping off, so every label reaching a message goes through this (RISKS.md/P0.7).
export const stripLabel = (label: string) => label.replace(/[<>]/g, '')

export const deviceLabel = (device: MediaDeviceInfo | undefined, all: MediaDeviceInfo[]): string => {
  if (!device) return ''
  const physical = ALIAS_IDS.includes(device.deviceId)
    ? all.find(d => d.groupId === device.groupId && !ALIAS_IDS.includes(d.deviceId))
    : undefined
  return stripLabel(physical?.label || device.label)
}
